import { QuestionId, StepId } from 'qualification/schema/model';
import { SCHEMA_QUESTIONS } from 'qualification/schema/questions';
import { SCHEMA_STEPS } from 'qualification/schema/steps';

export const stepsArray = Object.values(SCHEMA_STEPS);

export function isMainQuestionId(id: string): id is StepId {
  const topLevelQuestionIds = stepsArray.map((q) => q.id);
  return topLevelQuestionIds.includes(id as StepId);
}

export const getQuestionById = <T extends QuestionId>(id: T) => {
  return SCHEMA_QUESTIONS[id];
};

export const getStepById = <T extends StepId>(id: T) => {
  return SCHEMA_STEPS[id];
};
